import { getIsAna2 } from '../utils/Ana2';
export const usePrice = (people, selectedOutboundFlight, selectedInboundFlight, plans = [], selectedOutboundDate) => {
  const adult = people ? people.adult || 2 : 2;
  const childrenA = people ? people.childrenA || 0 : 0;
  const childrenB = people ? people.childrenB || 0 : 0;
  const childrenC = people ? people.childrenC || 0 : 0;
  const children2 = people ? people.children2 || 0 : 0;
  const infant = people ? people.infant || 0 : 0;

  let totalAdultPrice = 0;
  let totalChildrenAPrice = 0;
  let totalChildrenBPrice = 0;
  let totalChildrenCPrice = 0;
  let totalChildren2Price = 0;
  let totalInfantPrice = 0;

  plans.forEach((p) => {
    const { adultPrice, childrenAPrice, childrenBPrice, childrenCPrice, children2Price, infantPrice } = p;
    totalAdultPrice += adultPrice;
    totalChildrenAPrice += childrenAPrice;
    totalChildrenBPrice += childrenBPrice;
    totalChildrenCPrice += childrenCPrice;
    totalChildren2Price += children2Price;
    totalInfantPrice += infantPrice;
  });

  const priceOutbound = selectedOutboundFlight ? selectedOutboundFlight.price : 0;
  const childPriceOutbound = selectedOutboundFlight ? selectedOutboundFlight.childPrice : 0;
  const priceInbound = selectedInboundFlight ? selectedInboundFlight.price : 0;
  const childPriceInbound = selectedInboundFlight ? selectedInboundFlight.childPrice : 0;

  const adultPriceFlight = priceOutbound + priceInbound;
  const childPriceFlight = childPriceOutbound + childPriceInbound;

  const pricePerAdult = (totalAdultPrice + adultPriceFlight);
  const pricePerChildrenA = (totalChildrenAPrice + childPriceFlight);
  const pricePerChildrenB = (totalChildrenBPrice + childPriceFlight);
  const pricePerChildrenC = (totalChildrenCPrice + childPriceFlight);
  const pricePerInfant = (totalInfantPrice + 0); //幼児はフライト料金が0円

  //ANA2の場合は2歳児席ありなのでフライト料金が発生するs
  const isAna2 = selectedOutboundFlight ? getIsAna2(selectedOutboundFlight.airline, selectedOutboundDate) : false;
  const child2PriceFlight = isAna2 ? childPriceFlight : 0;
  const pricePerChildren2 = (totalChildren2Price + child2PriceFlight);

  const totalPrice =
    pricePerAdult * adult + pricePerChildrenA * childrenA + pricePerChildrenB * childrenB + pricePerChildrenC * childrenC + pricePerChildren2 * children2 + pricePerInfant * infant;

  return { totalPrice, pricePerAdult, pricePerChildrenA, pricePerChildrenB, pricePerChildrenC, pricePerChildren2, pricePerInfant };
};
